import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Input } from 'components'
import styles from '../index.module.css'
import { BellIcon, SettingIcon } from 'components/HeaderComponents'
import carImg1 from 'images/tmp_fincar_image01.png'
import carImg2 from 'images/tmp_fincar_image02.png'
import carImg3 from 'images/tmp_fincar_image03.png'
import carImg4 from 'images/tmp_fincar_image04.png'

const Fincar = () => {

	const App = useApp()
	const [lifeTab, setLifeTab] = useState(0)
	const [recommendTab, setRecommendTab] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <><BellIcon /><SettingIcon /></>,
		})

		App.setShowNav(true)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pb_50">
					<h2>핀카</h2>
					<div className={styles["top-btn-group"]}>
						<p>갖고 싶은 내차 전문가에게</p>
						<div>
							<span className={`${styles["my-btn"]} ${styles.new}`}>
								<i className="icon icon_my_line ml_5" />
							</span>
							<span className={styles["compare-btn"]}>
								<i className="icon icon_compare_line" />
							</span>
						</div>
					</div>

					{/* 클릭 시 차량조회 페이지로 이동 */}
					<div className="form-group search-bar mt_30">
						<Input style={{ background: "#fff" }} placeholder="원하는 차량을 찾아보세요." disabled />
						<i className="icon icon_search" />
					</div>
				</div>
			</div>

			{/* 내 관심차량 */}
			<div className="shadow">
				<div className="padding py_30">
					<div className="flex-justify_between align_center">
						<h3>내 관심차량</h3>
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>
				</div>
				<div className="no-scroll pb_50" style={{ overflowX: "auto" }}>
					<ul className={`${styles["car-list"]} ${styles["type-inline"]}`}>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg1} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg2} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* 상담 예약 리스트 */}
			<div className="shadow">
				<div className="padding py_30">
					<ul className={styles["reser-list"]}>
						<li>
							<span>김**</span>
							<span>방문 상담 예약</span>
							<span>04/21</span>
							<span>예약</span>
						</li>
						<li>
							<span>유**</span>
							<span>셀프 시승 예약</span>
							<span>04/21</span>
							<span>예약</span>
						</li>
						<li>
							<span>황**</span>
							<span>동승 시승 예약</span>
							<span>04/21</span>
							<span>예약</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 30대 남성 인기 차량 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3><span className="text-blue">30대 남성</span> <span>인기 차량</span></h3>
					<div className={`${styles["box-area"]} mt_20`}>
						<div className="flex-justify_between align_center">
							<div>
								<p>1,2위 차량이 궁금하다면?</p>
								<span className={`${styles.guide} mt_10`}>조건 추가하고 새로운 인기 차량도 확인해보세요.</span>
							</div>
							<i className="icon icon_arrow_sm icon_arrow_md right" />
						</div>
					</div>
					<ul className={`${styles["pop-car"]} mt_30`}>
						<li>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_gold`} />
								<div className={`img-box ${styles.blur}`}>
									<img src={carImg1} alt="" />
								</div>
							</div>
							<div className={`${styles.txt} flex_1`}>
								<p className={styles.blur}>기아 EV6</p>
								<div className={styles.price}>
									<strong className="text-blue">3,600~4,200</strong> 만원
								</div>
							</div>
						</li>
						<li>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_silver`} />
								<div className={`img-box ${styles.blur}`}>
									<img src={carImg2} alt="" />
								</div>
							</div>
							<div className={`${styles.txt} flex_1`}>
								<p className={styles.blur}>현대 그랜져</p>
								<div className={styles.price}>
									<strong className="text-blue">5,600~6,800</strong> 만원
								</div>
							</div>
						</li>
						<li>
							<div className="flex-align_center">
								<i className={`${styles.medal} icon icon_medal_bronze`} />
								<div className="img-box">
									<img src={carImg4} alt="" />
								</div>
							</div>
							<div className={`${styles.txt} flex_1`}>
								<p>현대 싼타페</p>
								<div className={styles.price}>
									<strong className="text-blue">5,600~6,800</strong> 만원
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* 마이데이터 연동 되어있지 않은 경우 배너 노출 */}
			<div className="shadow">
				<div className={`${styles.banner} padding`}>
					<i className="icon" />
					<strong className="ml_20">마이데이터를 연결하면<br />더 다양한 혜택이!</strong>
				</div>
			</div>

			{/* 마이데이터 연동 되어있는 경우 마이데이터 추천 차량 노출 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3>마이데이터 추천 차량</h3>
				</div>
				<div className="no-scroll pb_50" style={{ overflowX: "auto" }}>
					<ul className={`${styles["car-list"]} ${styles["type-inline"]}`}>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg3} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg4} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* Life style 추천 */}
			<div className="shadow">
				<div className="padding pt_30 pb_20">
					<div className="flex-justify_between align_center">
						<h3>Life style 추천</h3>
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>
				</div>
				<div className="no-scroll" style={{ overflowX: "auto" }}>
					<ul className="tab-round no-wrap">
						<li onClick={() => setLifeTab(0)} className={lifeTab === 0 ? "active" : ""}>#캠핑</li>
						<li onClick={() => setLifeTab(1)} className={lifeTab === 1 ? "active" : ""}>#초년생</li>
						<li onClick={() => setLifeTab(2)} className={lifeTab === 2 ? "active" : ""}>#커플</li>
						<li onClick={() => setLifeTab(3)} className={lifeTab === 3 ? "active" : ""}>#친환경</li>
						<li onClick={() => setLifeTab(4)} className={lifeTab === 4 ? "active" : ""}>#NEW</li>
					</ul>
				</div>
				<div className="padding pb_50">
					<ul className={`${styles["car-list"]} ${styles["type-group"]}`}>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg1} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg2} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg3} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg4} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* 핀카 추천 */}
			<div>
				<div className="padding pt_30 pb_20">
					<div className="flex-justify_between align_center">
						<h3>핀카 추천</h3>
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>
				</div>
				<div className="no-scroll" style={{ overflowX: "auto" }}>
					<ul className="tab-round no-wrap">
						<li onClick={() => setRecommendTab(0)} className={recommendTab === 0 ? "active" : ""}>#급매물</li>
						<li onClick={() => setRecommendTab(1)} className={recommendTab === 1 ? "active" : ""}>#NEW</li>
						<li onClick={() => setRecommendTab(2)} className={recommendTab === 2 ? "active" : ""}>#신차급</li>
						<li onClick={() => setRecommendTab(3)} className={recommendTab === 3 ? "active" : ""}>#컨설턴트</li>
						<li onClick={() => setRecommendTab(4)} className={recommendTab === 4 ? "active" : ""}>#NEW</li>
					</ul>
				</div>
				<div className="padding pb_50">
					<ul className={`${styles["car-list"]} ${styles["type-group"]}`}>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg1} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg2} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg3} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>르노삼성 SM6 2.0 GDe RE</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className={styles.info}>
								<div className={`${styles["car-img"]} img-box`}>
									<img src={carImg4} alt="" />

									{/* on/off */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>
								</div>
								<div className={`${styles.txt} mt_20`}>
									<div className={styles.title}>현대 싼타페 더 프라임 디젤 R2.0 2WD 5인승</div>
									<span>21년식 67,000km</span>
									<div className={styles.price}>
										<strong>6,500</strong> 만원
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}

export default Fincar